import React from "react";
import { Plan } from "@/types/plans";
import NumberFlow from "@number-flow/react";

interface PlanPriceProps {
  plan: Plan;
  isYearly: boolean;
  showPricing: boolean;
}

export const PlanPrice: React.FC<PlanPriceProps> = ({ plan, isYearly, showPricing }) => {
  const isFree = plan?.name?.toLocaleLowerCase().includes("free");

  const currentPrice = isYearly ? plan.price?.yearly : plan.price?.monthly;

  // If pricing is hidden and not free plan, show contact message
  if (!showPricing && !isFree) {
    return (
      <div>
        <p className="text-2xl font-bold text-foreground">Custom</p>
        <p className="text-xs text-muted-foreground">Contact for pricing</p>
      </div>
    );
  }

  if (!currentPrice) {
    return (
      <div>
        <p className="text-2xl font-bold text-foreground">Custom</p>
        <p className="text-xs text-muted-foreground">Contact for pricing</p>
      </div>
    );
  }

  if (isFree) {
    return (
      <div className="w-full text-center">
        <p className="text-3xl font-bold text-foreground">Free</p>
        <p className="text-xs text-green-600 font-medium mt-1">
          7 days access to all features
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <p className="text-3xl font-bold text-foreground ">
        {/* ${displayPrice / 100} */}
        <NumberFlow
          format={{
            style: "currency",
            currency: "USD",
          }}
          value={currentPrice.amount_cents / 100}
          className="text-4xl font-bold"
        />
      </p>
      <p className="text-xs text-muted-foreground ml-2 mt-1">
        {isYearly ? "per year/organization" : "per month/organization"}
      </p>
    </div>
  );
};
